"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnClickOutside_1 = require("./OnClickOutside");
exports.default = OnClickOutside_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/behaviors/OnClickOutside/index.js
// module id = 1298
// module chunks = 8